// extracted by mini-css-extract-plugin
export var columnList = "_gq-0";